import 'Plugins/filteringPlugin';

export default function initSearch(data) {
	jQuery('.filtration-finder').filteringItems({
		container: '.address-col',
		items: '.item-place',
		filterLinks: '[data-filter]',
		filterHolder: '.finder-open-close',
		onInit: function() {
			this.page = jQuery('html, body');
			this.mapAPI = this.holder.find('.mapbox-holder').data('Mapbox');
			this.searchForm = jQuery('.finder-section .search-form');

			let flag = false;

			this.filterSelects.each(function() {
				const select = jQuery(this);
				const type = select.data('filter-group');
				const value = getUrlAttr(type);
				const options = select.find('option');

				if (value !== '') {
					options.each(function(ind) {
						const option = jQuery(this);

						if (option.attr('value').trim().toLocaleLowerCase() === value) {
							select.prop('selectedIndex', ind);

							jcf.refresh(select);
						}
					});

					flag = true;
				}
			});

			if (flag) {
				this.filter();

				setTimeout(() => {
					this.page.animate({
						scrollTop: this.holder.offset().top
					}, 500);
				}, 500);
			}

			this.searchForm.on('onSearch', (e, ...values) => {
				if (values.length) {
					for (let i = 0; i < values.length; i++) {
						const type = values[i].type;
						const value = values[i].value;

						this.holder.find(`select[data-filter-group="${type}"]`).each(function() {
							const select = jQuery(this);
							const options = select.find('option');

							options.each(function(ind) {
								const option = jQuery(this);

								if (option.attr('value').trim().toLocaleLowerCase() === value) {
									select.prop('selectedIndex', ind);

									jcf.refresh(select);
								}
							});
						});
					}

					this.filter();
				} else {
					this.resetFilter();
				}

				this.page.animate({
					scrollTop: this.holder.offset().top
				}, 500);
			});
		},
		onFilter: function(items, filters) {
			let filterItems = data;

			jQuery.each(filters, function(key, value) {
				filterItems = filterItems.filter(function(item) {
					var textArr = (typeof item[key] === 'string') ? item[key].split(',') : item[key];
					var matched = false;

					for (var i = 0; i < textArr.length; i++) {
						if (value.includes(textArr[i].trim().toLowerCase())) {
							matched = true;
						}
					}

					return matched;
				});
			});

			setTimeout(() => {
				if (this.mapAPI) {
					this.mapAPI.removeMarkers();

					if (filterItems && Object.keys(filterItems).length > 0) {
						this.mapAPI.prepareMarkers(filterItems);
					}
				}
			});
		}
	});
}

function getUrlAttr(name) {
	var value = name.replace(/[\[]/, '\\\[').replace(/[\]]/, '\\\]');
	var regexS = '[\\?&]' + value + '=([^&#]*)';
	var regex = new RegExp(regexS);
	var results = regex.exec(window.location.href);

	if (results === null) {
		return '';
	} else {
		return results[1];
	}
}